"use client"

import { School } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SchoolIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SchoolIcon = component(Icon)({ as: School })
